export const TextFieldRules = {
  REQUIRED: (value: string) =>
    (value !== undefined && value !== null && value !== '') || 'Benötigt.',
  TEXT: (value: string) => value === '' || 'Benötigt.',
  COUNTER_AREA: (value: string) =>
    value.length < 250 ||
    'Notifications dürchen nicht mehr als 250 Zeichen beinhalten',
  REDEMPTION_CODE: (value: string) => {
    const pattern = /^[a-zA-Z0-9!@#$%^&*)(+=._-]+$/
    return pattern.test(value) || 'Codes dürfen kein Komma beinhalten'
  },
  REDEMPTION_CODE_LIST: (value: string) => {
    const pattern = /^[a-zA-Z0-9!@#$%^&*)(+=.,_-]+$/
    return (
      pattern.test(value) ||
      'Codes dürfen Buchstaben von A-Z und Ziffern von 0-9 beinhalten'
    )
  },
  EMAIL: (value: string) => {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Ungültige E-Mail-Adresse'
  },
  LINK: (value: string) => {
    const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gim
    return pattern.test(value) || value.trim().length === 0 || 'Ungültiger Link'
  },
  OPTIONAL_LINK: (value: string) => {
    if (!value || value.trim().length === 0) {
      return true
    }

    const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gim
    return pattern.test(value) || 'Ungültiger Link'
  },
  UUID: (uuid: string) => {
    const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    return (
      pattern.test(uuid) ||
      'Ungültige UUID, z.B. 20354d7a-e4fe-47af-8ff6-187bca92f3f9'
    )
  },
  FILESIZE_SINGLE: (file: File) => {
    return (
      !file || file.size < 4194304 || 'Bilder dürfen maximal 4 MB groß sein.'
    )
  },
  FILESIZE_MULTI: (files: File[]) =>
    !files ||
    files.every((file: File) => file.size < 4194304) ||
    'Bilder dürfen maximal 4 MB groß sein.',
  PASSWORD: (value: string) =>
    value.length >= 6 || 'Das Passwort muss mindestens 6 Zeichen haben.',
  OPTIONAL_PHONE: (value: string) => {
    if (!value) return true
    if (value[0] === '+') {
      if (value.length < 4) return 'Telefonnummer ist zu kurz.'
    } else if (value[0] === '0') {
      if (value.length < 3) return 'Telefonnummer ist zu kurz.'
      if (value[1] === '0')
        return 'Bitte "+" verwenden für internationale Telefonnummern.'
    } else {
      return 'Die Telefonnummer muss mit 0 oder + beginnen.'
    }

    const pattern = /^\+?[0-9- ]+$/
    if (!pattern.test(value)) {
      return 'Bitte nur Ziffern, Leerzeichen, + oder - benutzen.'
    }
    return true
  }
}

export const MaxLengthValidator = {
  TEXT_FIELD: 50,
  EMAIL: 75
}

export const UserRole = {
  USER: 'user',
  ADMIN: 'admin',
  SUPERADMIN: 'superadmin',
  PARTNER: 'partner',
  LIGHTPARTNER: 'lightpartner'
}

export const CategoryType = {
  LOCAL: 'local',
  ONLINE: 'e_commerce',
  REWARDS: 'rewards'
}

export const CompanyType = {
  LOCAL: 'local',
  ONLINE: 'e_commerce',
  REWARDS: 'rewards'
}

export const CompanyTypeText: { [k: string]: string } = {
  LOCAL: 'Lokal',
  ONLINE: 'E-Commerce',
  REWARDS: 'Belohnung'
}

export const DiscountType = {
  RELIEF: 'relief',
  DISCOUNT: 'discount',
  PERCENTAGE: 'percentage',
  FREEITEMS: 'free_items',
  GOODIES: 'goodies',
  COUPON: 'coupon',
  INFO: 'info'
}

export const DiscountTypeText: { [k: string]: string } = {
  RELIEF: 'Minderung',
  DISCOUNT: 'Rabatt',
  PERCENTAGE: 'Prozent',
  FREEITEMS: 'Gratis',
  GOODIES: 'Goodies',
  COUPON: 'Wertgutschein',
  INFO: 'Info/News'
}

export const DealMediaType = {
  IMAGE: 'image',
  VIDEO: 'video'
}

export const RedemptionType = {
  SINGLE_IN: 'single_in',
  SINGLE_OUT: 'single_out',
  MULTI_IN: 'multi_in',
  MULTI_OUT: 'multi_out',
  NONE: 'none'
}

export const RedemptionTypeText: { [k: string]: string } = {
  SINGLE_IN: 'Einzelcode (eingehend)',
  SINGLE_OUT: 'Einzelcode (ausgehend)',
  MULTI_IN: 'Multicode (eingehend)',
  MULTI_OUT: 'Multicode (ausgehend)',
  NONE: 'Keine Codes'
}

export const DealType = {
  ECOMMERCE: 'e_commerce',
  LOCAL: 'local',
  REWARDS: 'rewards'
}

export const DealTypeText: { [k: string]: string } = {
  ECOMMERCE: 'E-Commerce',
  LOCAL: 'Lokal',
  REWARDS: 'Belohnung'
}

export const DealStatus = {
  ACTIVE: 'active',
  DELETED: 'deleted',
  DRAFT: 'draft',
  REVIEW_PENDING: 'review_pending',
  REVIEWED: 'reviewed',
  CHANGES_PENDING: 'changes_pending',
  APPROVED: 'approved',
  PAUSED: 'paused',
  EXPIRED: 'expired',
  HIDDEN: 'hidden'
}

export const DealStatusText: { [k: string]: string } = {
  ACTIVE: 'Aktiv',
  DELETED: 'Gelöscht',
  DRAFT: 'Entwurf',
  REVIEW_PENDING: 'Prüfung ausstehend',
  REVIEWED: 'Geprüft',
  CHANGES_PENDING: 'Warten auf Änderungen',
  APPROVED: 'Freigegeben',
  PAUSED: 'Pausiert',
  EXPIRED: 'Abgelaufen',
  HIDDEN: 'Ungelistet'
}

export const DealStatusColor: { [k: string]: string } = {
  ACTIVE: 'primary',
  DELETED: 'error',
  DRAFT: 'secondary',
  REVIEW_PENDING: 'warning',
  REVIEWED: 'info',
  CHANGES_PENDING: 'warning',
  APPROVED: 'success',
  PAUSED: 'warning',
  EXPIRED: 'error'
}

export const DealCardType = {
  LOCAL: 'local',
  ONLINE: 'e_commerce',
  SPECIFIC: 'specific',
  URL: 'url'
}

export const DefaultCardList = {
  NAME: 'FeaturedCardList'
}

export const RewardType = {
  INVITE: 'invite'
}

export const ListType = {
  WHITELABEL: 'whitelabel',
  COMPANY: 'company',
  BEACON: 'beacon',
  TAG: 'tag',
  PROMOTION_CODE: 'promotion-code',
  USER: 'user',
  VENUE: 'venue',
  DEAL: 'deal',
  CARD: 'card',
  CARDLIST: 'cardList',
  ADMIN: 'admin',
  PARTNER: 'partner'
}

export const Gender = {
  FEMALE: 0,
  MALE: 1,
  NEUTRAL: 2
}

export const GenderText: { [k: string]: string } = {
  FEMALE: 'Weiblich',
  MALE: 'Männlich',
  NEUTRAL: 'Divers'
}
